module.exports = __webpack_public_path__ + "img/icon-1.ea23fd98.png";